import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { XCircle } from 'lucide-react';
import { motion } from 'framer-motion';

const PaymentCancelPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center p-4" style={{ background: 'linear-gradient(135deg, #D1FAE5 0%, #FEF3C7 100%)' }}>
      <motion.div initial={{ opacity: 0, scale: 0.95 }} animate={{ opacity: 1, scale: 1 }} className="w-full max-w-md">
        <Card className="p-8 rounded-3xl shadow-lg border-2 border-slate-200 text-center" data-testid="payment-cancel-card">
          <img
            src="https://customer-assets.emergentagent.com/job_e77e6e6f-0eb9-4cf5-990d-5085ee85d2a5/artifacts/o9we2o4z_file_00000000b8947207b6be688fc35a0ba2.png"
            alt="Prof. Scaly"
            className="w-24 h-24 mx-auto mb-4 object-contain"
          />
          <div className="bg-slate-100 rounded-full p-4 w-20 h-20 flex items-center justify-center mx-auto mb-4">
            <XCircle className="w-12 h-12 text-slate-500" strokeWidth={2.5} />
          </div>
          <h1 className="text-2xl font-heading font-bold text-slate-800 mb-2" data-testid="payment-cancel-title">Payment Cancelled</h1>
          <p className="text-slate-600 mb-6">No worries — no charges were made. You can subscribe anytime to unlock unlimited practice.</p>
          <div className="flex gap-3">
            <Button
              onClick={() => navigate('/subscription')}
              className="flex-1 bg-emerald-500 hover:bg-emerald-600 text-white rounded-full py-6 font-bold tactile-button border-emerald-700"
              data-testid="cancel-try-again"
            >
              Try Again
            </Button>
            <Button
              onClick={() => navigate('/dashboard')}
              variant="outline"
              className="flex-1 rounded-full py-6 font-bold"
              data-testid="cancel-go-to-dashboard"
            >
              Back to Dashboard
            </Button>
          </div>
        </Card>
      </motion.div>
    </div>
  );
};

export default PaymentCancelPage;
